import http from "../../http-common";

const SystemConfigTicket = {
    getListTicket: (id, name, page, limit, type) => {
       return http.get(`/master/system-config/getListTicket?idSchool=${id}&nameTicket=${name}&typeTicket=${type}&pageNumber=${page}&maxPageItem=${limit}`)
    },

    getListTemplateSystem: (id, name, page, limit, type) => {
        return http.get(`/master/system-config/getListTicketSample?idSchool=${id}&nameTicket=${name}&typeTicket=${type}&pageNumber=${page}&maxPageItem=${limit}`)
    },

    createTicketAppSystem: (formData) => {
        return http.post(`/master/system-config/create-Ticket-Sample`, formData);
    },

    createTicketAppSchool: (formData) => {
        return http.post(`/master/system-config/create-update`, formData);
    },

    updateTicketAppSystem: (formData) => {
        return http.put(`/master/system-config/update-Ticket-Sample`, formData);
    },

    getDetail: (id) => {
        return http.get(`/master/system-config/sample/${id}`);
    },

    deleteTicketAppSystem: (id) => {
        return http.delete(`/master/system-config/deleteTicketSample?idTicketSample=${id}`);
    },

    getListSchoolTicketApply: (id) => {
        return http.get(`/master/system-config/listSchoolTicketApply?idTicketSample=${id}`);
    },

    setDefaultTicketAppSystem: (id) => {
        return http.get(`/master/system-config/setDefaultTicKet?idTicket=${id}`);
    },

    getDetailTicketMasterSchool: (id) => {
        return http.get(`/master/system-config/ticket/${id}`)
    },

    deleteTicketAppSchool: (id) => {
        return http.delete(`/master/system-config/${id}`)
    },

    deleteMultiTicket: (ids) => {
        return http.delete(`/master/system-config/deleteManyTicket?idTicketList=${ids}`);
    }
}

export default SystemConfigTicket;